import { ApplicationContext } from '@wix/editor-platform-contexts';
import { BaseSDKShape } from '../BaseSDKShape';
import { PlatformSDKShape } from '../PlatformSDKShape';
import {
  ListProvidersOptions,
  Provider,
} from '@wix/public-editor-platform-interfaces';

export class ProvidersPublicSDKShape extends BaseSDKShape {
  constructor(
    protected overriddenApplicationContext: Promise<ApplicationContext> | null = null,
    private childPath: number[] = [],
  ) {
    super(overriddenApplicationContext);
  }

  async attach(providerIdentifier: string, data?: Object): Promise<void> {
    const privateAPI = await this.getPlatformPrivateAPI();
    const manifestContextId = await this.getRequiredManifestContextId();
    const result = await privateAPI.providers.attach(
      manifestContextId,
      this.childPath,
      providerIdentifier,
      data,
    );

    return result;
  }

  async detach(providerIdentifier: string): Promise<void> {
    const privateAPI = await this.getPlatformPrivateAPI();
    const manifestContextId = await this.getRequiredManifestContextId();
    const result = await privateAPI.providers.detach(
      manifestContextId,
      this.childPath,
      providerIdentifier,
    );

    return result;
  }

  async list(options?: ListProvidersOptions): Promise<Provider[]> {
    const privateAPI = await this.getPlatformPrivateAPI();
    const manifestContextId = await this.getRequiredManifestContextId();
    const result = await privateAPI.providers.list(
      manifestContextId,
      this.childPath,
      options,
    );

    return result;
  }
}

export const providersPublicSDKShape = new PlatformSDKShape(
  ProvidersPublicSDKShape,
)
  .withPublicMethod('attach')
  .withPublicMethod('detach')
  .withPublicMethod('list')
  .build();
